import { render, staticRenderFns } from "./OverlayUI.vue?vue&type=template&id=f73bdd00&scoped=true&"
import script from "./OverlayUI.vue?vue&type=script&lang=js&"
export * from "./OverlayUI.vue?vue&type=script&lang=js&"
import style0 from "./OverlayUI.vue?vue&type=style&index=0&id=f73bdd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73bdd00",
  null
  
)

export default component.exports